// extracted by mini-css-extract-plugin
module.exports = {"productImage":"_10UiK","productBadge":"_3gSRI","badge":"_2EGAu","defaultImage":"_1PKeP"};